import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Arquivo from '../../../../components/auth/leis/listar/form_arquivo'


function ArquivoLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Substituindo Arquivo - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Arquivo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ArquivoLeiScreen;